<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import StatusTag from 'dashboard/components-next/tag/StatusTag.vue';
import { resolveBuyerProfileKind } from '../utils/crmPageUtils';

const props = defineProps({
  profile: { type: Object, default: null },
  businessContext: { type: String, default: '' },
  size: { type: String, default: 'xs' },
});

const { t } = useI18n();

const kind = computed(() =>
  resolveBuyerProfileKind(props.profile, props.businessContext)
);
const label = computed(
  () =>
    ({
      investor: t('LEADS.BUYER_PROFILE.INVESTOR'),
      home: t('LEADS.BUYER_PROFILE.HOME'),
      profile: t('LEADS.BUYER_PROFILE.PROFILE'),
    })[kind.value] || ''
);
</script>

<template>
  <span>
    <StatusTag v-if="label" :label="label" variant="attention" :size="size" />
  </span>
</template>
